import { email, required, Validator } from '@/entities/validation';
import { ProfileUpdatingUser } from './model';

export const validate: Validator<ProfileUpdatingUser> = user => [
  ...required(user.name, 'name'),
  ...required(user.email, 'email'),
  ...email(user.email, 'email'),
  ...required(user.locale, 'locale'),
];
